export enum OauthFacebookTypeEnum {
  Code = 1,
  AccessToken = 2,
}